import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="production-dashboard"
export default class extends Controller {
  static targets = ["timestamp"]

  connect() {
    // Auto-refresh every 5 minutes (300000 milliseconds)
    this.refreshInterval = setInterval(() => {
      this.refresh()
    }, 300000)

    // Update timestamp every second for visual feedback
    this.timestampInterval = setInterval(() => {
      this.updateTimestamp()
    }, 1000)
  }

  disconnect() {
    // Clean up intervals when controller is disconnected
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
    if (this.timestampInterval) {
      clearInterval(this.timestampInterval)
    }
  }

  refresh() {
    // Reload the page to get fresh data
    window.location.reload()
  }

  updateTimestamp() {
    // Update the timestamp display to current time
    const now = new Date()
    const hours = now.getHours()
    const minutes = now.getMinutes()
    const ampm = hours >= 12 ? 'PM' : 'AM'
    const displayHours = hours % 12 || 12
    const displayMinutes = minutes.toString().padStart(2, '0')

    if (this.hasTimestampTarget) {
      this.timestampTarget.textContent = `${displayHours}:${displayMinutes} ${ampm}`
    }
  }
}
